<template>
  <div>
    <v-container fluid>
      <!-- <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('API External Log') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      <h2 class="heading-text">API External Log</h2>
      <div class="mt-2 mb-4"><hr /></div>

      <v-card class="card2">
        <v-row align="center">
          <v-col cols="12" md="6" style="display: flex; align-items: center">
            <v-text-field
              id="username-field-search-usermanagement"
              v-model="apiEndPoint"
              placeholder="API Endpoint"
              hide-details
              variant="plain"
              class="search-input"
              density="comfortable"
              @input="searchData"
              @click:clear="clearSearch"
            >
              <template #prepend-inner>
                <img
                  class="search-icon"
                  src="@/assets/flowbite_search-outline.svg"
                  alt="Search"
                  width="20"
                  height="20"
                />
              </template>
            </v-text-field>
          </v-col>

          <!-- <v-col cols="12" md="4" style="display: flex; align-items: center">
            <v-text-field
              id="username-field-search-usermanagement"
              label="Search..."
              density="comfortable"
              variant="outlined"
              prepend-inner-icon="mdi-text-box-search-outline"
              hide-details
              clearable
              v-model="search"
              color="primary"
            ></v-text-field>
          </v-col> -->

          <v-col md="6" cols="12" class="d-flex flex-wrap justify-end gap-2">
            <!-- <v-btn variant="text" size="large" class="search-btn" @click="searchData" prepend-icon="mdi-magnify">
              {{ $t('Search') }}
            </v-btn> -->
            <div class="advance-filters" style="gap: 1rem;">
              <div style="display: flex; justify-content: flex-start; align-items: center; gap: 8px;">
                <img src="@/assets/cuida_filter-outline.svg" alt="img" width="20" height="20" />
                <span style="color: #C32E0E; font-size: 12px;">Advance Filters</span>
                <v-switch v-model="drawer" class="memory-switch" hide-details></v-switch>
                <div class="action-divider"></div>
              </div>
              <div>
                <button class="download-btn" type="button" @click="exportToExcel">
                  <img src="@/assets/bxs_download.svg" alt="img" width="20" height="20" />
                  <span style="color: #ffffff; font-size: 14px;">{{ $t('Download') }}</span>
                </button>
              </div>
            </div>
          </v-col>
        </v-row>

        <v-card v-if="drawer" class="advanced-filter-card mt-8 pa-4 mb-2">
          <div class="d-flex align-center gap-2">
            <img src="@/assets/cuida_filter-outline.svg" alt="img" width="20" height="20" />
            <p class="card-title">Filters Options</p>
          </div>
          <v-row class="mt-2">
            <!-- Start Date -->
            <v-col cols="12" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="Start Date" class="text-sm font-medium text-gray-700">
                  Start Date
                </label>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Select start date for filtering.</span>
                </v-tooltip>
              </div>
              <v-menu v-model="filter.startDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
                <template #activator="{ props }">
                  <v-text-field
                    v-model="filter.startDate"
                    readonly
                    variant="plain"
                    v-bind="props"
                    density="compact"
                    color="grey"
                    class="date-style"
                  >
                    <template #prepend-inner>
                      <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px;" />
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  @update:model-value="
                    (val) => {
                      filter.startDate = formatDate(val);
                      filter.startDateFlag = false;
                    }
                  "
                  color="red"
                  :max="new Date()"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- End Date -->
            <v-col cols="12" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="End Date" class="text-sm font-medium text-gray-700">
                  End Date
                </label>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Select end date for filtering.</span>
                </v-tooltip>
              </div>
              <v-menu v-model="filter.endDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
                <template #activator="{ props }">
                  <v-text-field
                    v-model="filter.endDate"
                    readonly
                    variant="plain"
                    v-bind="props"
                    density="compact"
                    color="grey"
                    class="date-style"
                  >
                    <template #prepend-inner>
                      <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px;" />
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.endDate"
                  :min="filter.startDate"
                  @update:model-value="
                    (val) => {
                      filter.endDate = formatDate(val);
                      filter.endDateFlag = false;
                    }
                  "
                  color="red"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <!-- Create By -->
            <v-col cols="12" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="Create By" class="text-sm font-medium text-gray-700">
                  Create By
                </label>
                <v-tooltip location="top" max-width="270px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Display the user account responsible for creating this entry.</span>
                </v-tooltip>
              </div>
              <v-text-field 
                v-model="draftFilter.createBy"
                variant="plain"
                density="comfortable"
                class="modern-input"
                placeholder="Create By"
                color="grey">
              </v-text-field>
            </v-col>

            <!-- Status Code -->
            <v-col cols="12" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="Status Code" class="text-sm font-medium text-gray-700">
                  Status Code
                </label>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>The numeric code that reports the result of a network request or API operation.</span>
                </v-tooltip>
              </div>
              <v-text-field
                placeholder="Status Code"
                v-model="draftFilter.statusCode"
                variant="plain"
                density="comfortable"
                class="modern-input"
                color="grey"
              >
              </v-text-field>
            </v-col>

            <!-- transaction id -->
            <v-col cols="12" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="Transaction ID" class="text-sm font-medium text-gray-700">
                  Transaction ID
                </label>
                <v-tooltip location="top" max-width="310px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Search for specific transaction using its unique ID.</span>
                </v-tooltip>
              </div>                                    
              <v-text-field
                placeholder="Transaction ID"
                v-model="draftFilter.transactionID"
                variant="plain"
                density="comfortable"
                class="modern-input"
                color="grey"
                >
              </v-text-field>
            </v-col>

            <!-- method -->
            <v-col cols="12" md="4">
              <div class="mb-1 d-flex align-center" style="gap: 2px">
                <label for="Method" class="text-sm font-medium text-gray-700">
                  Method
                </label>
                <v-tooltip location="top" max-width="300px">
                  <template v-slot:activator="{ props }">
                    <img
                      v-bind="props"
                      src="@/assets/intent group toolip.svg"
                      alt="info"
                      width="18"
                      height="18"
                      style="cursor: pointer; margin-left: 4px;"
                    />
                  </template>
                  <span>Filter by API request method.</span>
                </v-tooltip>
              </div>
              <v-select
                variant="plain"
                density="comfortable"
                placeholder="Method"
                :items="['GET', 'POST', 'PUT', 'DELETE']"
                v-model="draftFilter.method"
                class="modern-input"
                color="grey"
              >
              </v-select>
            </v-col>
          </v-row>

          <v-row class="pa-4" justify="end" style="margin-top: -8px;">
            <div class="filter-button">
              <button type="button" class="apply-filter-btn" @click="applyFilter">
                <span style="color: #ffffff; font-size: 14px;">Apply Filter</span>
              </button>

              <button type="button" class="clear-button" @click="clearAll">
                <img src="@/assets/charm_cross.svg" alt="img" width="22" height="22" />
                <span class="filter-by">{{ $t("ClearFilters") }}</span>
              </button>
            </div>
          </v-row>
        </v-card>
      </v-card>

      <v-card class="template-table-wrapper mt-6">
        <!-- table -->
        <v-card-text style="padding: 0">
          <v-card-text>
            <h2 style="font-weight: 600; color: #171717;">API External Log</h2>
          </v-card-text>
          <v-data-table-server
            v-model:options="option"
            :items-per-page="option.itemsPerPage"
            :items-length="searchTotalTable"
            :items="apiExternalData"
            :headers="headers"
            class="pa-4"
            :loading="loadingTable"
          >
            <!-- <template #top>
              <v-toolbar flat color="grey-lighten-4" class="table-toolbar">
                <v-toolbar-title class="text-h6 font-weight-medium">
                  <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                  Api External Log ({{ searchTotalTable }} records)
                </v-toolbar-title>
              </v-toolbar>
            </template> -->
            <template #no-data>
              <div class="d-flex justify-center align-center fixed" style="width: 100%">
                <span style="color: #646464; font-weight: 400;">{{ $t('No data available') }}</span>
              </div>
            </template>

            <template v-slot:item="{ item, index }">
              <tr>
                <td style="text-align: left">{{ (option.page - 1) * option.itemsPerPage + index + 1 }}</td>
                <td style="text-align: left; max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  <v-tooltip v-if="item.transactionID && item.transactionID.length > 20" location="top">
                    <template #activator="{ props }">
                      <span v-bind="props" style="cursor: pointer;">
                        {{ item.transactionID.slice(0, 20) + '...' }}
                      </span>
                    </template>
                    <span>{{ item.transactionID }}</span>
                  </v-tooltip>
                  <span v-else>
                    {{ item.transactionID ? item.transactionID : '-' }}
                  </span>
                </td>
                <td style="text-align: left">
                  <div
                    :style="[
                      item.method === 'GET'
                        ? 'color: #3859D0'
                        : item.method === 'POST'
                        ? 'color: #2ABF56'
                        : item.method === 'PUT'
                        ? 'color: #872612'
                        : item.method === 'DELETE'
                        ? 'color: #ED1C24'
                        : '',
                    ]"
                  >
                    {{ item.method }}
                  </div>
                </td>
                <td style="text-align: left; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  <v-tooltip location="top">
                    <template #activator="{ props }">
                      <span v-bind="props" style="cursor: pointer;">
                        {{ item.apiEndPoint }}
                      </span>
                    </template>
                    <span>{{ item.apiEndPoint }}</span>
                  </v-tooltip>
                </td>
                <td style="text-align: left">{{ item.statusCode }}</td>
                <td style="text-align: left; max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  <v-tooltip v-if="item.createBy && item.createBy.length > 20" location="top">
                    <template #activator="{ props }">
                      <span v-bind="props" style="cursor: pointer;">
                        {{ item.createBy.length > 20 ? item.createBy.slice(0, 20) + '...' : item.createBy }}
                      </span>
                    </template>
                    <span>{{ item.createBy }}</span>
                  </v-tooltip>
                  <span v-else>
                    {{ item.createBy }}
                  </span>
                </td>
                <td style="text-align: left">{{ formatDateTable(item.createDate) }}</td>
                <td style="text-align: center">
                  <v-col cols="auto">
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <button v-bind="props" type="button" variant="plain" @click="GetApiExternalById(item.apiExternalID)">
                          <img src="@/assets/details.svg" alt="img" width="50" height="50" />
                        </button>
                      </template>
                      <span>View Details</span>
                    </v-tooltip>
                  </v-col>
                </td>
              </tr>
            </template>

            <template v-slot:bottom>
              <div class="table-bottom-group">
                <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                  <span style="color: #171717; font-size: 13px;">Total results {{ searchTotalTable }}</span>
    
                  <v-data-table-footer
                    :items="[
                      { text: '10', value: 10 },
                      { text: '25', value: 25 },
                      { text: '50', value: 50 },
                      { text: '100', value: 100 },
                      { text: 'All', value: -1 },
                    ]"
                    :page="option.page"
                    :length="Math.ceil(searchTotalTable / option.itemsPerPage)"
                  />
                </div>
              </div>
            </template>

            <!-- <template #no-data>
              <div class="text-center pa-8">
                <v-icon size="48" color="grey-lighten-1" class="mb-4">mdi-database-off</v-icon>
                <h3 class="text-grey-lighten-1 mb-2">{{ $t('No data available') }}</h3>
                <p class="text-grey-lighten-2">{{ $t('No API logs found matching your criteria') }}</p>
              </div>
            </template> -->
          </v-data-table-server>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- dialog API External Detail -->
    <v-dialog max-width="800" max-height="600" v-model="dialogApiExternalDetail" persistent>
      <template v-slot:default>
        <v-card >
          <v-card-text>
            <h3 style="color: #171717; font-weight: 600;">API External Detail</h3>
            <p style="color: #646464; font-size: 14px;">Specific Detail For API Endpoint</p>
          </v-card-text>
          <div style="margin-top: -6px;">
            <hr>
          </div>
          <v-card-text>
            <div class="d-flex justify-start align-center gap-2">
              <img src="@/assets/mdi_information-variant-box.svg" alt="img" width="20" height="20">
              <p style="color: #171717; font-size: 18px;">Information</p>
            </div>
          </v-card-text>
          <v-card-text>
            <v-row class="pa-3" style="margin-top: -40px;">
              <v-card class="pa-4 mb-4">
                <v-row>
                  <v-col cols="3">
                    <div class="detail-information">
                      <h4>Transaction ID</h4>
                      <p>:</p>
                    </div>
                  </v-col>
                  <v-col cols="9">
                    <pre class="font-detail mb-0">{{ apiExternalDetail.transactionID ? apiExternalDetail.transactionID : '-' }}</pre>
                  </v-col>
                
                  <v-col cols="3">
                    <div class="detail-information">
                      <h4>API Endpoint</h4>
                      <p>:</p>
                    </div>
                  </v-col>
                  <v-col cols="9">
                    <span class="font-detail">{{ apiExternalDetail.apiEndPoint }}</span>
                  </v-col>

                  <v-col cols="3">
                      <div class="detail-information">
                        <h4>Method</h4>
                        <p>:</p>
                      </div>
                  </v-col>
                  <v-col cols="9">
                    <span class="text-detail mb-0">{{ apiExternalDetail.method }}</span>
                  </v-col>

                  <v-col cols="3">
                    <div class="detail-information">
                      <h4>Status Code</h4>
                      <p>:</p>
                    </div>
                  </v-col>
                  <v-col cols="9">
                    <span class="text-detail mb-0">{{ apiExternalDetail.statusCode }}</span>
                  </v-col>

                  <v-col cols="3">
                    <div class="detail-information">
                      <h4>Create By</h4>
                      <p>:</p>
                    </div>
                  </v-col>
                  <v-col cols="9">
                    <span class="text-detail mb-0">{{ apiExternalDetail.createBy }}</span>
                  </v-col>

                  <v-col cols="3">
                    <div class="detail-information">
                      <h4>Create Date</h4>
                      <p>:</p>
                    </div>
                  </v-col>
                  <v-col cols="9">
                    <span class="text-detail mb-0">{{ formatDateTable(apiExternalDetail.createDate) }}</span>
                  </v-col>
                </v-row>
              </v-card>

              <v-expansion-panels>
                <v-expansion-panel class="response-panel" title="Request Body">
                  <v-expansion-panel-text>
                    <!-- <span>{{ apiExternalDetail.requestBody }}</span> -->
                    <div class="response-container">
                      <pre class="content">{{ apiExternalDetail.requestBody }}</pre>
                    </div>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-expansion-panels class="mt-2" variant="accordion" style="">
                <v-expansion-panel class="response-panel" title="JSON Response">
                  <v-expansion-panel-text>
                    <div class="response-container">
                      <pre class="content">{{ apiExternalDetail.jsonResponse }}</pre>
                    </div>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <button type="button" class="btn-save" variant="elevated" @click="dialogApiExternalDetail = false">
              <img src="@/assets/line-md_close.svg" alt="img" width="16" height="16" />
              <span style="color: #C32E0E; font-weight: 500; font-size: 13px;">Close</span>
            </button>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- loading Pleas wait -->
    <v-dialog :model-value="dialog" class="align-center justify-center" persistent max-width="350px">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';

export default {
  name: 'LogAPIExternal',
  inject: ['SubNavbarBackGround', 'FontColorTitle', 'flagNav'],

  data() {
    return {
      apiExternalData: [],
      apiEndPoint: '',
      headers: [],
      today: null,
      dialog: false,
      drawer: false,
      dialogApiExternalDetail: false,

      draftFilter: {
        transactionID: '',
        method: null,
        statusCode: '',
        createBy: '',
        endDate: null,
        startDate: null,
      },
    
      appliedFilter: {
        transactionID: '',
        method: null,
        statusCode: '',
        createBy: '',
        endDate: null,
        startDate: null,
      },

      filter: {
        transactionID: '',
        method: null,
        statusCode: '',
        createBy: '',
        endDate: null,
        endDateFlag: false,
        startDate: null,
        startDateFlag: false,
      },
      option: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      
      searchTotalTable: 0,
    };
  },

  methods: {
    clearSearch() {
      this.searchName = null;
      this.options.page = 1;
      this.GetApiExternal();
    },
    searchData() {
      this.options.page = 1;
      this.GetApiExternal();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },

    GetApiExternal() {
    this.loadingTable = true;

    let { page, itemsPerPage, sortBy } = this.option;
    let sortField = null;
    let sortOrder = null;
    if (sortBy && sortBy.length > 0) {
      sortField = sortBy[0].key;
      sortOrder = sortBy[0].order === 'desc';
    }

    // Handle "All" option - when itemsPerPage is -1, use total count
    let itemsPerPageValue = itemsPerPage;
    if (itemsPerPage === -1) {
      itemsPerPageValue = this.searchTotalTable > 0 ? this.searchTotalTable : 999999;
    }

    let temp = {
      page: itemsPerPage === -1 ? 1 : page,
      itemsPerPage: itemsPerPageValue,
      sortBy: sortField,
      sortDesc: sortOrder,

      apiEndPoint: this.apiEndPoint,

      // Filter parameters
      transactionID: this.appliedFilter.transactionID,
      method: this.appliedFilter.method,
      statusCode: this.appliedFilter.statusCode,
      createBy: this.appliedFilter.createBy,
      startDate: this.appliedFilter.startDate == null ? this.formatDate(new Date()) : this.appliedFilter.startDate,
      endDate: this.appliedFilter.endDate == null ? this.formatDate(new Date()) : this.appliedFilter.endDate,
    };
    
    this.$call.GetApiExternal(
      temp,
      (response) => {
        if (response.status == 0) {
          this.searchTotalTable = response.data.total;
          this.apiExternalData = response.data.data;
          this.option.page = response.data.page;
        } else {
          this.searchTotalTable = 0;
          this.apiExternalData = [];
        }
        this.loadingTable = false;
      },
      (error) => {
        this.loadingTable = false;
        console.error('Error fetching API external logs:', error);
      }
    );
  },

    GetApiExternalById(id) {
      this.dialog = true;
      this.$call.GetApiExternalById(
        id,
        (response) => {
          if (response.status == 0) {
            this.apiExternalDetail = response.data.data;
            this.dialog = false;
            this.dialogApiExternalDetail = true;
          } else {
            this.apiExternalDetail = {};
            this.dialogApiExternalDetail = false;
            console.error('Error fetching API external log details:', response.message);
          }
          this.dialog = false;
        },
        (error) => {
          this.dialog = false;
          console.error('Error fetching API external log by ID:', error);
        }
      );
    },

    formatDateTable(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },

    formatDate(dateInput) {
      if (!dateInput) {
        return '';
      }
      if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const date = `${year}-${month}-${day}`;
      return date;
    },

    clearAll() {
      this.draftFilter.transactionID = '';
      this.draftFilter.method = null;
      this.draftFilter.statusCode = '';
      this.draftFilter.createBy = '';
      this.draftFilter.startDate = this.formatDate(new Date());
      this.draftFilter.endDate = this.formatDate(new Date());

      this.filter.transactionID = '';
      this.filter.method = null;
      this.filter.statusCode = '';
      this.filter.createBy = '';
      this.filter.startDate = this.formatDate(new Date());
      this.filter.endDate = this.formatDate(new Date());
      this.applyFilter();
    },
    applyFilter() {
      this.appliedFilter.transactionID = this.draftFilter.transactionID;
      this.appliedFilter.method = this.draftFilter.method;
      this.appliedFilter.statusCode = this.draftFilter.statusCode;
      this.appliedFilter.createBy = this.draftFilter.createBy;
      this.appliedFilter.startDate = this.draftFilter.startDate;
      this.appliedFilter.endDate = this.draftFilter.endDate;
      this.option.page = 1;
      this.GetApiExternal();
    },
    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
    convertDateToString(date, seperator = '/') {
            return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    }, 
    exportToExcel(){
      this.dialog = true;

      let { page, itemsPerPage, sortBy } = this.option;
      let sortField = null;
      let sortOrder = null;
      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        // Pagination parameters
        page: page,
        itemsPerPage: itemsPerPage,
        sortBy: sortField,
        sortDesc: sortOrder,

        apiEndPoint: this.apiEndPoint,

        // Filter parameters
        transactionID: this.filter.transactionID,
        method: this.filter.method,
        statusCode: this.filter.statusCode,
        createBy: this.filter.createBy,
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
      };
      this.$call.ExportApiExternal(
        temp,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `API_LOG_${this.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          this.dialog = false;
        },
        (error) => {
          this.dialog = false;
          console.error('Error exporting API external logs:', error);
        }
      );
    }
  },

  watch: {
    option: {
      handler() {
        this.GetApiExternal();
      },
      deep: true,
      immediate: false,
    },

    draftFilter: {
      handler(newVal) {
        this.filter.transactionID = newVal.transactionID;
        this.filter.method = newVal.method;
        this.filter.statusCode = newVal.statusCode;
        this.filter.createBy = newVal.createBy;
        this.filter.startDate = newVal.startDate;
        this.filter.endDate = newVal.endDate;
      },
      deep: true,
      immediate: true,
    },

    filter: {
      handler(newVal) {
        this.draftFilter.transactionID = newVal.transactionID;
        this.draftFilter.method = newVal.method;
        this.draftFilter.statusCode = newVal.statusCode;
        this.draftFilter.createBy = newVal.createBy;
        this.draftFilter.startDate = newVal.startDate;
        this.draftFilter.endDate = newVal.endDate;
      },
      deep: true,
    },
  },

  mounted() {
    this.headers = [
      {
        title: this.$t('no'),
        align: 'left',
        sortable: false,
      },
      {
        title: this.$t('Transaction ID'),
        align: 'left',
        sortable: true,
        value: 'transactionID',
      },
      {
        title: this.$t('Method'),
        align: 'left',
        sortable: true,
        value: 'method',
      },
      {
        title: this.$t('Api EndPoint'),
        align: 'left',
        sortable: true,
        value: 'Api EndPoint',
      },
      { title: 'Status code', align: 'left', sortable: true, value: 'statusCode' },
      {
        title: this.$t('Create by'),
        align: 'left',
        sortable: false,
        value: 'createdBy',
      },
      {
        title: this.$t('Create date'),
        align: 'left',
        sortable: true,
        value: 'createdDate',
      },
      {
        title: this.$t('Details'),
        align: 'center',
        sortable: false,
      },
    ];
    const today = this.formatDate(new Date());
    this.draftFilter.startDate = today;
    this.draftFilter.endDate = today;
    this.appliedFilter.startDate = today;
    this.appliedFilter.endDate = today;
    this.filter.startDate = today;
    this.filter.endDate = today;
    this.GetDate();
    this.GetApiExternal();
    // this.GetApiExternal();
  },
};
</script>

<style scoped>
.card2 {
  border: 1px solid #DCDCDC;
  border-radius: 10px !important;
  box-shadow: none;
  padding: 18px;
}
.heading-text {
  color: #171717;
  font-weight: 600;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.search-input {
  max-width: 280px;
  background: white;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-input :deep(.v-field__field) {
  align-items: center;
}
.search-input :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.search-icon {
  margin-left: 12px;
  margin-top: -2px;
  height: 18px;
}
.download-btn {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 120px;
  justify-content: center;
  align-items: center;
  padding: 9px;
  gap: 6px;
}
.apply-filter-btn {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 10px;
}
.download-btn:hover, .apply-filter-btn:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.advance-filters {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}
/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}
/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;
  
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) { display: none !important; }
.v-input--density-default {
    --v-input-control-height: none;
}
.action-divider {
  display: flex;
  align-items: center;
  width: 2px;
  height: 38px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
  transition: background-color 0.2s ease;
}
.advanced-filter-card {
  background: rgba(239, 244, 255, 0.5) !important;
  border-radius: 16px;
  box-shadow: none;
}
.card-title {
  color: #171717;
  font-weight: 600;
  font-size: 14px;
}
.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
}
.modern-input :deep(.v-field) {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
}

.modern-input :deep(.v-field:hover) {
  background-color: #f1f5f9 !important;
}
.modern-input :deep(.v-field__input) {
  padding: 8px 12px !important;
}

.modern-input :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
  margin-top: -5px;
}
.modern-input :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.modern-input :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.filter-button {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}
.clear-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 10px;
  border-radius: 10px;
}
.clear-button:hover {
  background: rgba(56, 89, 208, 0.1);
  border-radius: 10px;
}
/* table style */
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
.table-bottom-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.detail-information {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.btn-save {
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  border: 1px solid #C32E0E;
  border-radius: 12px;
  padding: 8px;
  gap: 8px;
  width: 90px;
}

/* fileter button */
.filter-btn {
  background: linear-gradient(45deg, #371f4c, #874dab);
  color: white;
  border-radius: 50%;
}

/* table */
.template-table-wrapper {
  border: 1px solid #c9c9c9;
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: none !important;
}

/* dialog detail */
.font-detail {
  white-space: pre-wrap;
  word-break: break-all;
  font-weight: 700;
  color: #333;
  font-size: 14px;
}
.text-detail {
  white-space: pre-wrap;
  word-break: break-all;
  font-weight: 400;
  color: #646464;
  font-size: 14px;
}

.search-btn {
  /* background primary */
  background: linear-gradient(45deg, #1565C0, #42A5F5);
  color: white;
  border-radius: 16px !important;
}

/* export-btn */
.export-btn {
  background: linear-gradient(45deg, rgb(27, 112, 34), rgba(55, 189, 66, 0.652));
  color: white;
  border-radius: 16px !important;
}

.filter-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
  border-bottom: rgb(229, 229, 229) solid 1px;
}

/* JSON Response Panel Styling */
.response-panel {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  background: rgba(231, 235, 255, 0.25) !important;
  font-weight: 600;
  color: #171717;
}

.response-panel:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.response-panel :deep(.v-expansion-panel-title),
.response-panel :deep(.v-expansion-panel-header) {
  background: #E7EBFF !important;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.response-container {
  background: #E7EBFF !important;
  border-radius: 4px;
  margin: 8px;
  border: 1px solid #e9ecef;
  max-height: 400px;
  overflow-y: auto;
}

.content {
  background: #2B2B2C;
  color: #ffffff;
  padding: 20px;
  margin: 0;
  font-family: 'Monaco', 'Fira Code', monospace;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  border-radius: 4px;
}

.content::-webkit-scrollbar {
  width: 8px;
}

.content::-webkit-scrollbar-thumb {
  background: #718096;
  border-radius: 4px;
}
</style>

